import React, { useEffect, useContext } from 'react';
import { getLeadStatus, fsPageOnLoad } from 'home/view/upgrade-order/utils';
import { LEAD_STATUS, ORDER_STATUS } from 'home/view/upgrade-order/constants';
import { CONTEXT } from 'home/view/upgrade-order/context';

import ExistingDetailsAccordion from 'home/view/upgrade-order/components/accordions/ExistingDetailsAccordion';
import UpgradeOrderDetailsAccordion from 'home/view/upgrade-order/components/accordions/UpgradeOrderDetailsAccordion';
import PricingQuotation from 'home/view/upgrade-order/components/accordions/PricingQuotation';
import OrderKycComponent from 'home/view/upgrade-order/components/accordions/OrderKycComponent';
import ThankYouPage from 'home/view/upgrade-order/components/common/ThankYouPage';
import LoaderComponent from 'home/view/upgrade-order/components/common/LoaderComponent';

const CustomerJourney = (props) => {
  const { leadData, pnqFormOpen, setIsPnqFormOpen, poFormOpen, setPoFormOpen, showThankYouPage = false, showCancelPage = false, orderDetail } = props;

  const { userType, params } = useContext(CONTEXT);

  useEffect(() => {
    fsPageOnLoad(leadData, userType);
  }, [leadData, userType]);

  useEffect(() => {
    if (leadData) {
      const leadStatus = getLeadStatus(leadData);

      const pnqFormShow = !(leadStatus === LEAD_STATUS.LEAD_IN_PROGRESS || leadStatus === LEAD_STATUS.FEASIBILITY_PENDING || leadStatus === LEAD_STATUS.LOCATION_NOT_FEASIBLE);

      let poFormShow = leadStatus === LEAD_STATUS.KYC_IN_PROGRESS || leadStatus === LEAD_STATUS.KYC_SUBMITTED;

      setIsPnqFormOpen(pnqFormShow);
      setPoFormOpen(poFormShow);
    }
  }, [leadData]);

  const isLeadCancelledOrSubmitted = (leadData) => {
    let isSubmittedOrCancelled = false;
    const { leadStatus = '' } = leadData;

    if (leadStatus === LEAD_STATUS.KYC_SUBMITTED || leadStatus === LEAD_STATUS.LEAD_CANCELLED || leadStatus === LEAD_STATUS.ORDER_CANCELLED) {
      isSubmittedOrCancelled = true;
    }

    return isSubmittedOrCancelled;
  };

  const checkIfOrderRejected = () => {
    if (orderDetail.orderStatus && orderDetail.orderStatus === ORDER_STATUS.OV_REJECTED) {
      return false;
    }
    return showThankYouPage || showCancelPage || isLeadCancelledOrSubmitted(leadData);
  };

  if (leadData.leadStatus === LEAD_STATUS.KYC_SUBMITTED && !!params.orderId && Object.keys(orderDetail).length === 0) {
    return (
      <>
        <LoaderComponent />
      </>
    );
  }

  return (
    <React.Fragment>
      {Object.keys(leadData).length > 0 ? (
        <div className="customer-journey">
          {checkIfOrderRejected() ? (
            <ThankYouPage {...props} showCancelPage={showCancelPage} />
          ) : (
            <React.Fragment>
              <ExistingDetailsAccordion {...props} />
              <UpgradeOrderDetailsAccordion {...props} />
              {pnqFormOpen && <PricingQuotation {...props} />}
              {poFormOpen && orderDetail.orderStatus && <OrderKycComponent {...props} />}
            </React.Fragment>
          )}
        </div>
      ) : null}
    </React.Fragment>
  );
};

export default CustomerJourney;
